/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';


/**
 * @summary Sign in with local credentials
 */
export const LoginBody = zod.object({
  "username": zod.string().describe('Username or email address.'),
  "password": zod.string()
})

export const LoginResponse = zod.object({
  "user": zod.object({
  "id": zod.string(),
  "email": zod.email().nullish(),
  "username": zod.string().nullish(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "role": zod.string(),
  "needsPasswordReset": zod.boolean().nullish(),
  "requiresTwoFactor": zod.boolean().optional(),
  "twoFactorMode": zod.enum(['setup', 'challenge', 'email-otp']).optional()
}),
  "tenant": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "slug": zod.string(),
  "planType": zod.string().nullish(),
  "subscriptionStatus": zod.string().nullish(),
  "trialEndsAt": zod.string().nullish()
})
})


/**
 * @summary Get the pending assistant's second-factor state
 */
export const GetTwoFactorStatusResponse = zod.object({
  "required": zod.boolean(),
  "mode": zod.union([zod.literal('setup'),zod.literal('challenge'),zod.literal('email-otp'),zod.literal(null)]).nullable(),
  "verified": zod.boolean()
})


/**
 * Returns the one-time enrollment secret. It is never returned after this response.
 * @summary Start TOTP enrollment
 */
export const SetupTwoFactorResponse = zod.object({
  "secret": zod.string(),
  "otpauthUri": zod.url()
}).describe('One-time enrollment response. Do not persist or log its secret.')


/**
 * @summary Confirm TOTP enrollment
 */



export const ConfirmTwoFactorBody = zod.object({
  "code": zod.string().min(1)
})

export const ConfirmTwoFactorResponse = zod.object({
  "ok": zod.literal(true),
  "verified": zod.literal(true),
  "recoveryCodes": zod.array(zod.string())
}).describe('Recovery codes are one-time confirmation material; do not persist or log them.')


/**
 * @summary Complete a TOTP challenge
 */



export const VerifyTwoFactorBody = zod.object({
  "code": zod.string().min(1)
})

export const verifyTwoFactorResponseRecoveryCodesRemainingMin = 0;



export const VerifyTwoFactorResponse = zod.object({
  "ok": zod.literal(true),
  "verified": zod.literal(true),
  "recoveryCodesRemaining": zod.int().min(verifyTwoFactorResponseRecoveryCodesRemainingMin).optional()
})


/**
 * @summary Complete a second-factor challenge with a recovery code
 */



export const VerifyTwoFactorRecoveryBody = zod.object({
  "code": zod.string().min(1)
})

export const verifyTwoFactorRecoveryResponseRecoveryCodesRemainingMin = 0;



export const VerifyTwoFactorRecoveryResponse = zod.object({
  "ok": zod.literal(true),
  "verified": zod.literal(true),
  "recoveryCodesRemaining": zod.int().min(verifyTwoFactorRecoveryResponseRecoveryCodesRemainingMin).optional()
})


/**
 * @summary Complete assistant email verification and optionally trust this device
 */



export const VerifyEmailOtpBody = zod.object({
  "code": zod.string().min(1),
  "trustDevice": zod.boolean().optional()
})

export const VerifyEmailOtpResponse = zod.object({
  "ok": zod.literal(true),
  "verified": zod.literal(true),
  "deviceTrustStatus": zod.enum(['not_requested', 'saved', 'failed'])
}).describe('Never includes the raw device token; the token is sent only as an HttpOnly cookie.')


/**
 * Returns the authenticated tenant's AI token consumption for the requested billing month (defaulting to the current month), plus the estimated billed cost (with platform upcharge) and the tenant's plan type. Usage is metered — no cap enforcement.
 * @summary AI token usage for one billing month
 */
export const getUserAiUsageQueryMonthRegExp = new RegExp('^\\d{4}-(0[1-9]|1[0-2])$');


export const GetUserAiUsageQueryParams = zod.object({
  "month": zod.coerce.string().regex(getUserAiUsageQueryMonthRegExp).optional().describe('Billing month to return, in YYYY-MM format. Defaults to the current billing month when omitted.')
})

export const GetUserAiUsageResponse = zod.object({
  "billingMonth": zod.string().describe('Billing period in YYYY-MM format'),
  "tokensUsed": zod.number().describe('Total tokens consumed this month'),
  "estimatedCostUsd": zod.number().describe('Estimated billed cost in USD (includes platform upcharge)'),
  "planType": zod.string().describe('Tenant plan type (free, pro, enterprise, …)'),
  "breakdown": zod.array(zod.object({
  "feature": zod.string().describe('Feature identifier (e.g. ai_coach, journal_insights)'),
  "tokensUsed": zod.number().describe('Tokens consumed by this feature this month'),
  "estimatedCostUsd": zod.number().describe('Estimated billed cost in USD (includes platform upcharge)')
}).describe('AI token usage attributed to a single feature.')).describe('Per-feature token usage for the requested billing month, sorted by token count descending. Features with zero usage are omitted.')
}).describe('AI token usage for one billing month for the authenticated tenant.')


/**
 * Returns the authenticated tenant's per-day AI token consumption for a single feature in the requested billing month (defaulting to the current month), with estimated billed cost (platform upcharge applied). Days are bucketed in UTC. Days with no usage are omitted.
 * @summary Per-day AI token usage for one feature
 */
export const getUserAiUsageDailyQueryMonthRegExp = new RegExp('^\\d{4}-(0[1-9]|1[0-2])$');


export const GetUserAiUsageDailyQueryParams = zod.object({
  "feature": zod.coerce.string().describe('Feature identifier to break down (e.g. ai_coach)'),
  "month": zod.coerce.string().regex(getUserAiUsageDailyQueryMonthRegExp).optional().describe('Billing month to return, in YYYY-MM format. Defaults to the current billing month when omitted.')
})

export const GetUserAiUsageDailyResponse = zod.object({
  "billingMonth": zod.string().describe('Billing period in YYYY-MM format'),
  "feature": zod.string().describe('Feature identifier the trend is for'),
  "days": zod.array(zod.object({
  "day": zod.string().describe('Day in YYYY-MM-DD format (UTC)'),
  "tokensUsed": zod.number().describe('Tokens consumed on this day'),
  "estimatedCostUsd": zod.number().describe('Estimated billed cost in USD (includes platform upcharge)')
}).describe('AI token usage for one UTC day.')).describe('Per-day usage buckets (UTC), ascending by day. Days without usage are omitted.')
}).describe('Per-day AI token usage for a single feature in one billing month for the authenticated tenant.')


/**
 * Returns the authenticated user and their tenant, or 401 when not logged in
 * @summary Get current authenticated user
 */
export const GetAuthUserResponse = zod.object({
  "user": zod.object({
  "id": zod.string(),
  "role": zod.string(),
  "tenantId": zod.string(),
  "email": zod.string().nullish(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "needsPasswordReset": zod.boolean().nullish(),
  "isMasterAdmin": zod.boolean(),
  "requiresTwoFactor": zod.boolean().optional().describe('True only when the current active assistant must complete second-factor authentication.'),
  "twoFactorMode": zod.enum(['setup', 'challenge', 'email-otp']).optional(),
  "twoFactorVerified": zod.boolean().optional()
}).describe('Sanitized authenticated user. The server strips the password hash and recomputes isMasterAdmin before responding; extra server-side fields may be present and should be ignored by clients.'),
  "tenant": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "slug": zod.string(),
  "planType": zod.string().nullish(),
  "subscriptionStatus": zod.string().nullish(),
  "trialEndsAt": zod.string().nullish()
})
})


/**
 * @summary List explicit grants for an owned contact
 */
export const ListContactSharesParams = zod.object({
  "id": zod.coerce.string()
})

export const ListContactSharesResponseItem = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "contactId": zod.string(),
  "ownerId": zod.string(),
  "sharedWithId": zod.string(),
  "permission": zod.enum(['view', 'edit']),
  "fieldScope": zod.array(zod.enum(['identity', 'contact', 'address', 'notes', 'documents'])),
  "createdAt": zod.coerce.date().optional(),
  "updatedAt": zod.coerce.date().optional()
})
export const ListContactSharesResponse = zod.array(ListContactSharesResponseItem)


/**
 * @summary Replace explicit grants for an owned contact
 */
export const ReplaceContactSharesParams = zod.object({
  "id": zod.coerce.string()
})

export const replaceContactSharesBodyRecipientsItemPermissionDefault = `view`;
export const replaceContactSharesBodyRecipientsMax = 100;



export const ReplaceContactSharesBody = zod.object({
  "recipients": zod.array(zod.object({
  "userId": zod.string(),
  "permission": zod.enum(['view', 'edit']).default(replaceContactSharesBodyRecipientsItemPermissionDefault),
  "fieldScope": zod.array(zod.enum(['identity', 'contact', 'address', 'notes', 'documents'])).min(1)
})).max(replaceContactSharesBodyRecipientsMax).optional(),
  "allEligible": zod.boolean().optional()
})

export const ReplaceContactSharesResponseItem = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "contactId": zod.string(),
  "ownerId": zod.string(),
  "sharedWithId": zod.string(),
  "permission": zod.enum(['view', 'edit']),
  "fieldScope": zod.array(zod.enum(['identity', 'contact', 'address', 'notes', 'documents'])),
  "createdAt": zod.coerce.date().optional(),
  "updatedAt": zod.coerce.date().optional()
})
export const ReplaceContactSharesResponse = zod.array(ReplaceContactSharesResponseItem)


/**
 * @summary Revoke one contact grant
 */
export const RevokeContactShareParams = zod.object({
  "id": zod.coerce.string(),
  "userId": zod.coerce.string()
})

export const RevokeContactShareResponse = zod.object({
  "success": zod.boolean()
})


/**
 * @summary List calendars shared by the caller
 */
export const ListCalendarSharesResponseItem = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "ownerId": zod.string(),
  "sharedWithId": zod.string(),
  "externalCalendarId": zod.string().nullish(),
  "permission": zod.enum(['view', 'edit']),
  "color": zod.string().nullish(),
  "label": zod.string().nullish(),
  "createdAt": zod.coerce.date().optional(),
  "updatedAt": zod.coerce.date().optional(),
  "sharedWith": zod.record(zod.string(), zod.unknown()).optional(),
  "owner": zod.record(zod.string(), zod.unknown()).optional(),
  "externalCalendar": zod.record(zod.string(), zod.unknown()).nullish(),
  "visibility": zod.record(zod.string(), zod.unknown()).optional()
})
export const ListCalendarSharesResponse = zod.array(ListCalendarSharesResponseItem)


/**
 * @summary Share a calendar with eligible recipients
 */

export const createCalendarShareBodyPermissionDefault = `view`;
export const createCalendarShareBodyColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createCalendarShareBodyLabelMax = 255;



export const CreateCalendarShareBody = zod.object({
  "sharedWithId": zod.string().optional(),
  "sharedWithIds": zod.array(zod.string()).min(1).optional(),
  "allEligible": zod.boolean().optional(),
  "externalCalendarId": zod.string().nullish(),
  "permission": zod.enum(['view', 'edit']).default(createCalendarShareBodyPermissionDefault),
  "color": zod.string().regex(createCalendarShareBodyColorRegExp).optional(),
  "label": zod.string().max(createCalendarShareBodyLabelMax).optional()
})

export const CreateCalendarShareResponse = zod.union([zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "ownerId": zod.string(),
  "sharedWithId": zod.string(),
  "externalCalendarId": zod.string().nullish(),
  "permission": zod.enum(['view', 'edit']),
  "color": zod.string().nullish(),
  "label": zod.string().nullish(),
  "createdAt": zod.coerce.date().optional(),
  "updatedAt": zod.coerce.date().optional(),
  "sharedWith": zod.record(zod.string(), zod.unknown()).optional(),
  "owner": zod.record(zod.string(), zod.unknown()).optional(),
  "externalCalendar": zod.record(zod.string(), zod.unknown()).nullish(),
  "visibility": zod.record(zod.string(), zod.unknown()).optional()
}),zod.array(zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "ownerId": zod.string(),
  "sharedWithId": zod.string(),
  "externalCalendarId": zod.string().nullish(),
  "permission": zod.enum(['view', 'edit']),
  "color": zod.string().nullish(),
  "label": zod.string().nullish(),
  "createdAt": zod.coerce.date().optional(),
  "updatedAt": zod.coerce.date().optional(),
  "sharedWith": zod.record(zod.string(), zod.unknown()).optional(),
  "owner": zod.record(zod.string(), zod.unknown()).optional(),
  "externalCalendar": zod.record(zod.string(), zod.unknown()).nullish(),
  "visibility": zod.record(zod.string(), zod.unknown()).optional()
}))])


/**
 * @summary List calendars shared with the caller
 */
export const ListCalendarsSharedWithMeResponseItem = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "ownerId": zod.string(),
  "sharedWithId": zod.string(),
  "externalCalendarId": zod.string().nullish(),
  "permission": zod.enum(['view', 'edit']),
  "color": zod.string().nullish(),
  "label": zod.string().nullish(),
  "createdAt": zod.coerce.date().optional(),
  "updatedAt": zod.coerce.date().optional(),
  "sharedWith": zod.record(zod.string(), zod.unknown()).optional(),
  "owner": zod.record(zod.string(), zod.unknown()).optional(),
  "externalCalendar": zod.record(zod.string(), zod.unknown()).nullish(),
  "visibility": zod.record(zod.string(), zod.unknown()).optional()
})
export const ListCalendarsSharedWithMeResponse = zod.array(ListCalendarsSharedWithMeResponseItem)


/**
 * @summary Update a calendar share created by the caller
 */
export const UpdateCalendarShareParams = zod.object({
  "shareId": zod.coerce.string()
})

export const UpdateCalendarShareBody = zod.object({
  "permission": zod.enum(['view', 'edit']).optional(),
  "color": zod.string().optional(),
  "label": zod.string().optional()
})

export const UpdateCalendarShareResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "ownerId": zod.string(),
  "sharedWithId": zod.string(),
  "externalCalendarId": zod.string().nullish(),
  "permission": zod.enum(['view', 'edit']),
  "color": zod.string().nullish(),
  "label": zod.string().nullish(),
  "createdAt": zod.coerce.date().optional(),
  "updatedAt": zod.coerce.date().optional(),
  "sharedWith": zod.record(zod.string(), zod.unknown()).optional(),
  "owner": zod.record(zod.string(), zod.unknown()).optional(),
  "externalCalendar": zod.record(zod.string(), zod.unknown()).nullish(),
  "visibility": zod.record(zod.string(), zod.unknown()).optional()
})


/**
 * @summary Revoke a calendar share created by the caller
 */
export const RevokeCalendarShareParams = zod.object({
  "shareId": zod.coerce.string()
})

export const RevokeCalendarShareResponse = zod.void()


/**
 * @summary Set visibility of a received calendar share
 */
export const UpdateCalendarShareVisibilityParams = zod.object({
  "shareId": zod.coerce.string()
})

export const UpdateCalendarShareVisibilityBody = zod.object({
  "isVisible": zod.boolean()
})

export const UpdateCalendarShareVisibilityResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "userId": zod.string(),
  "calendarShareId": zod.string(),
  "isVisible": zod.boolean()
})


/**
 * @summary List events visible through received calendar shares
 */
export const ListSharedCalendarEventsQueryParams = zod.object({
  "startDate": zod.date().optional(),
  "endDate": zod.date().optional()
})

export const ListSharedCalendarEventsResponseItem = zod.object({
  "id": zod.string(),
  "isSharedEvent": zod.literal(true)
}).describe('Provider connection and provider event identifiers are intentionally excluded.')
export const ListSharedCalendarEventsResponse = zod.array(ListSharedCalendarEventsResponseItem)


/**
 * @summary Get live effective capability grants for the current assistant
 */
export const GetAssistantEffectivePermissionsResponse = zod.object({
  "assistantType": zod.enum(['assistant', 'virtual_assistant', 'coach']),
  "permissions": zod.object({
  "notes": zod.boolean(),
  "goals": zod.boolean(),
  "calendar": zod.boolean(),
  "tasks": zod.boolean(),
  "notepad": zod.boolean(),
  "habits": zod.boolean(),
  "trackerX": zod.boolean(),
  "contacts": zod.boolean(),
  "ai": zod.boolean(),
  "mcp": zod.boolean(),
  "retellInbound": zod.boolean(),
  "retellOutbound": zod.boolean(),
  "vault": zod.boolean(),
  "media": zod.boolean(),
  "planner": zod.boolean(),
  "intentions": zod.boolean(),
  "gratefuls": zod.boolean(),
  "incantations": zod.boolean(),
  "checklists": zod.boolean(),
  "drive": zod.boolean(),
  "meditation": zod.boolean(),
  "analytics": zod.boolean(),
  "vboard": zod.boolean(),
  "sops": zod.boolean(),
  "timeBudget": zod.boolean(),
  "suggestions": zod.boolean()
})
})


/**
 * @summary Update a managed assistant profile and its capability grants
 */
export const UpdateAssistantProfileParams = zod.object({
  "userId": zod.coerce.string()
})

export const UpdateAssistantProfileBody = zod.object({
  "assistantType": zod.enum(['assistant', 'virtual_assistant', 'coach']).optional(),
  "status": zod.enum(['active', 'suspended', 'inactive']).optional(),
  "hourlyRate": zod.number().nullish(),
  "permissions": zod.object({
  "notes": zod.boolean(),
  "goals": zod.boolean(),
  "calendar": zod.boolean(),
  "tasks": zod.boolean(),
  "notepad": zod.boolean(),
  "habits": zod.boolean(),
  "trackerX": zod.boolean(),
  "contacts": zod.boolean(),
  "ai": zod.boolean(),
  "mcp": zod.boolean(),
  "retellInbound": zod.boolean(),
  "retellOutbound": zod.boolean(),
  "vault": zod.boolean(),
  "media": zod.boolean(),
  "planner": zod.boolean(),
  "intentions": zod.boolean(),
  "gratefuls": zod.boolean(),
  "incantations": zod.boolean(),
  "checklists": zod.boolean(),
  "drive": zod.boolean(),
  "meditation": zod.boolean(),
  "analytics": zod.boolean(),
  "vboard": zod.boolean(),
  "sops": zod.boolean(),
  "timeBudget": zod.boolean(),
  "suggestions": zod.boolean()
}).optional()
})

export const UpdateAssistantProfileResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "userId": zod.string(),
  "managerUserId": zod.string(),
  "assistantType": zod.enum(['assistant', 'virtual_assistant', 'coach']),
  "permissions": zod.object({
  "notes": zod.boolean(),
  "goals": zod.boolean(),
  "calendar": zod.boolean(),
  "tasks": zod.boolean(),
  "notepad": zod.boolean(),
  "habits": zod.boolean(),
  "trackerX": zod.boolean(),
  "contacts": zod.boolean(),
  "ai": zod.boolean(),
  "mcp": zod.boolean(),
  "retellInbound": zod.boolean(),
  "retellOutbound": zod.boolean(),
  "vault": zod.boolean(),
  "media": zod.boolean(),
  "planner": zod.boolean(),
  "intentions": zod.boolean(),
  "gratefuls": zod.boolean(),
  "incantations": zod.boolean(),
  "checklists": zod.boolean(),
  "drive": zod.boolean(),
  "meditation": zod.boolean(),
  "analytics": zod.boolean(),
  "vboard": zod.boolean(),
  "sops": zod.boolean(),
  "timeBudget": zod.boolean(),
  "suggestions": zod.boolean()
}),
  "status": zod.enum(['active', 'suspended', 'inactive']),
  "hourlyRate": zod.number().nullish(),
  "createdAt": zod.coerce.date().optional(),
  "updatedAt": zod.coerce.date().optional()
})


/**
 * Returns users for the caller's tenant (admin) with the tenant name joined in. Master admins see all users across tenants, or can filter with the tenantId query parameter.
 * @summary List users
 */
export const ListUsersQueryParams = zod.object({
  "tenantId": zod.coerce.string().optional().describe('Master admin only — restrict results to this tenant')
})

export const ListUsersResponseItem = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "email": zod.string().nullish(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "username": zod.string().nullish(),
  "role": zod.string(),
  "isMasterAdmin": zod.boolean(),
  "createdAt": zod.string().nullish().describe('ISO timestamp of when the user was created'),
  "tenantName": zod.string().nullish()
}).describe('Row returned by GET \/users — base user columns plus the tenant name joined server-side (null when the tenant join misses).')
export const ListUsersResponse = zod.array(ListUsersResponseItem)


/**
 * Returns every tenant with a per-tenant user count and a summary list of its users. Master admin only.
 * @summary List all tenants (master admin)
 */
export const ListAdminTenantsResponseItem = zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "slug": zod.string(),
  "planType": zod.string().nullish(),
  "currentPlanId": zod.string().nullish(),
  "maxUsers": zod.int().nullish(),
  "maxGoals": zod.int().nullish(),
  "isActive": zod.boolean().nullish(),
  "status": zod.string().nullish(),
  "createdAt": zod.string().nullish().describe('ISO timestamp of when the tenant was created'),
  "userCount": zod.int(),
  "users": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "email": zod.string(),
  "role": zod.string()
}).describe('Compact per-user summary embedded in the admin tenant list'))
}).describe('Tenant row returned by GET \/admin\/tenants with user summaries')
export const ListAdminTenantsResponse = zod.array(ListAdminTenantsResponseItem)


/**
 * Returns all configured subscription/reseller plans. Master admin only.
 * @summary List subscription plans (master admin)
 */
export const ListResellerPlansResponseItem = zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "displayName": zod.string().optional(),
  "description": zod.string().nullish(),
  "price": zod.int().optional().describe('Price in cents'),
  "currency": zod.string().optional(),
  "interval": zod.string().optional().describe('Billing interval, e.g. month or year'),
  "maxUsers": zod.int().optional(),
  "maxGoals": zod.int().optional(),
  "storageLimitMb": zod.int().nullish(),
  "isActive": zod.boolean(),
  "isFeatured": zod.boolean().optional(),
  "displayOrder": zod.int().optional()
}).describe('Subscription\/reseller plan. Additional server-side columns (Stripe ids, plan feature JSON, upcharges) may be present and should be ignored by clients that don\'t need them.')
export const ListResellerPlansResponse = zod.array(ListResellerPlansResponseItem)


/**
 * Returns invitations for the caller's tenant (admin). Master admins see all invitations across tenants, or can filter with the tenantId query parameter. The plaintext invitation token is never included.
 * @summary List user invitations
 */
export const ListUserInvitationsQueryParams = zod.object({
  "tenantId": zod.coerce.string().optional().describe('Master admin only — restrict results to this tenant')
})

export const ListUserInvitationsResponseItem = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "inviterUserId": zod.string(),
  "email": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "role": zod.string().describe('Invited role, e.g. admin or user'),
  "invitationType": zod.string().describe('reseller (provisions a new tenant) or member'),
  "preferredTenantName": zod.string().nullish(),
  "status": zod.string().describe('pending, accepted, expired, or cancelled'),
  "expiresAt": zod.string().describe('ISO timestamp when the invitation expires'),
  "acceptedAt": zod.string().nullish(),
  "migrationStatus": zod.string().nullish(),
  "migratedAt": zod.string().nullish(),
  "migratedToTenantId": zod.string().nullish(),
  "lastSentAt": zod.string().nullish(),
  "createdAt": zod.string(),
  "updatedAt": zod.string()
}).describe('Invitation row as returned by the API — every user_invitations column except the plaintext token, which is never exposed to callers. Timestamps are ISO strings.')
export const ListUserInvitationsResponse = zod.array(ListUserInvitationsResponseItem)


/**
 * Creates an invitation and emails the invitee. Master admins may target another tenant via tenantId and create reseller/admin invitations; tenant admins are restricted to member invitations in their own tenant.
 * @summary Create a user invitation
 */
export const CreateUserInvitationBody = zod.object({
  "email": zod.email(),
  "firstName": zod.string().optional(),
  "lastName": zod.string().optional(),
  "role": zod.enum(['user', 'admin']).describe('Admin role requires master-admin privileges'),
  "tenantId": zod.string().optional().describe('Master admin only — target tenant for the invitation'),
  "invitationType": zod.enum(['member', 'reseller']).optional().describe('Master admin only — reseller or member (default member); reseller requires master-admin privileges'),
  "preferredTenantName": zod.string().optional().describe('Optional tenant\/family name for reseller invitations')
})

export const CreateUserInvitationResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "inviterUserId": zod.string(),
  "email": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "role": zod.string().describe('Invited role, e.g. admin or user'),
  "invitationType": zod.string().describe('reseller (provisions a new tenant) or member'),
  "preferredTenantName": zod.string().nullish(),
  "status": zod.string().describe('pending, accepted, expired, or cancelled'),
  "expiresAt": zod.string().describe('ISO timestamp when the invitation expires'),
  "acceptedAt": zod.string().nullish(),
  "migrationStatus": zod.string().nullish(),
  "migratedAt": zod.string().nullish(),
  "migratedToTenantId": zod.string().nullish(),
  "lastSentAt": zod.string().nullish(),
  "createdAt": zod.string(),
  "updatedAt": zod.string()
}).describe('Invitation row as returned by the API — every user_invitations column except the plaintext token, which is never exposed to callers. Timestamps are ISO strings.').and(zod.object({
  "emailSent": zod.boolean().describe('Whether the invitation email was delivered')
}))


/**
 * Updates email, first/last name, or role of a pending invitation. Only master admins may grant the admin role.
 * @summary Edit a pending invitation
 */
export const UpdateUserInvitationParams = zod.object({
  "id": zod.coerce.string()
})

export const UpdateUserInvitationBody = zod.object({
  "email": zod.email().optional(),
  "firstName": zod.string().optional(),
  "lastName": zod.string().optional(),
  "role": zod.enum(['user', 'admin']).optional()
}).describe('Only email, firstName, lastName, and role may be edited')

export const UpdateUserInvitationResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "inviterUserId": zod.string(),
  "email": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "role": zod.string().describe('Invited role, e.g. admin or user'),
  "invitationType": zod.string().describe('reseller (provisions a new tenant) or member'),
  "preferredTenantName": zod.string().nullish(),
  "status": zod.string().describe('pending, accepted, expired, or cancelled'),
  "expiresAt": zod.string().describe('ISO timestamp when the invitation expires'),
  "acceptedAt": zod.string().nullish(),
  "migrationStatus": zod.string().nullish(),
  "migratedAt": zod.string().nullish(),
  "migratedToTenantId": zod.string().nullish(),
  "lastSentAt": zod.string().nullish(),
  "createdAt": zod.string(),
  "updatedAt": zod.string()
}).describe('Invitation row as returned by the API — every user_invitations column except the plaintext token, which is never exposed to callers. Timestamps are ISO strings.')


/**
 * Deletes an invitation. For accepted invitations, also deletes the user account that was created (force=true required when that user has data).
 * @summary Revoke an invitation
 */
export const DeleteUserInvitationParams = zod.object({
  "id": zod.coerce.string()
})

export const DeleteUserInvitationQueryParams = zod.object({
  "force": zod.coerce.boolean().optional().describe('Confirm deletion of an accepted invitation\'s user data')
})

export const DeleteUserInvitationResponse = zod.object({
  "success": zod.boolean()
})


/**
 * @summary Bulk-clear expired and cancelled invitations
 */
export const ClearStaleUserInvitationsQueryParams = zod.object({
  "tenantId": zod.coerce.string().optional().describe('Master admin only — clear for this tenant')
})

export const ClearStaleUserInvitationsResponse = zod.object({
  "success": zod.boolean(),
  "deletedCount": zod.int()
})


/**
 * Rotates the invitation token, resets expiry to 7 days out, flips expired invitations back to pending, and re-sends the email.
 * @summary Resend an invitation email
 */
export const ResendUserInvitationParams = zod.object({
  "id": zod.coerce.string()
})

export const ResendUserInvitationResponse = zod.object({
  "success": zod.boolean(),
  "emailSent": zod.boolean().describe('Whether the invitation email was delivered')
})


/**
 * Generates a temporary password for the user, invalidates outstanding reset links, and emails the temporary password to them. Tenant-scoped.
 * @summary Reset a user's password (admin)
 */
export const ResetUserPasswordParams = zod.object({
  "id": zod.coerce.string()
})

export const ResetUserPasswordResponse = zod.object({
  "success": zod.boolean(),
  "message": zod.string()
})


/**
 * Returns counts of the user's AI conversations, goals, tasks, habits, and journal entries plus human-readable warnings. Used by the delete user and revoke-accepted-invitation dialogs.
 * @summary Preview data loss before deleting a user
 */
export const GetUserDeletionPreviewParams = zod.object({
  "id": zod.coerce.string()
})

export const GetUserDeletionPreviewResponse = zod.object({
  "userId": zod.string(),
  "conversationCount": zod.int(),
  "lastConversationAt": zod.string().nullable().describe('ISO timestamp of the user\'s most recent AI conversation'),
  "goalCount": zod.int(),
  "taskCount": zod.int(),
  "habitCount": zod.int(),
  "journalEntryCount": zod.int(),
  "warnings": zod.array(zod.string()),
  "permanentLoss": zod.boolean()
}).describe('Impact summary shown before deleting a user (or revoking an accepted invitation, which also deletes the user account).')


/**
 * Aggregates AI conversation counts across the given users. Users that don't exist or belong to another tenant are silently skipped.
 * @summary Preview data loss before bulk-deleting users
 */



export const GetBatchUserDeletionPreviewBody = zod.object({
  "userIds": zod.array(zod.string()).min(1)
})

export const GetBatchUserDeletionPreviewResponse = zod.object({
  "userIds": zod.array(zod.string()),
  "totalConversationCount": zod.int(),
  "mostRecentLastActiveAt": zod.string().nullable().describe('ISO timestamp of the most recent AI conversation across the users'),
  "permanentLoss": zod.boolean()
})


/**
 * Atomically migrates a user and all of their data to the target tenant. Master admin only; callers cannot move their own account.
 * @summary Move a user to another tenant (master admin)
 */
export const MoveUserToTenantBody = zod.object({
  "userId": zod.string(),
  "targetTenantId": zod.string()
})

export const MoveUserToTenantResponse = zod.object({
  "success": zod.boolean(),
  "user": zod.object({
  "id": zod.string(),
  "email": zod.string().nullish(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "tenantId": zod.string()
}),
  "userDetails": zod.object({
  "email": zod.string().nullish(),
  "name": zod.string()
}).optional(),
  "sourceTenant": zod.string(),
  "targetTenant": zod.string(),
  "message": zod.string()
})


/**
 * Assigns the tenant to the given subscription plan, or unassigns it when planId is null. Master admin only.
 * @summary Change a tenant's subscription plan (master admin)
 */
export const UpdateTenantPlanParams = zod.object({
  "id": zod.coerce.string()
})

export const UpdateTenantPlanBody = zod.object({
  "planId": zod.string().nullable().describe('Plan to assign, or null to unassign the current plan')
})

export const UpdateTenantPlanResponse = zod.object({
  "message": zod.string(),
  "tenant": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "slug": zod.string(),
  "planType": zod.string().nullish(),
  "currentPlanId": zod.string().nullish()
}).describe('Tenant row returned after a plan change. Additional server-side columns may be present and should be ignored by clients.')
})


/**
 * Returns all API keys for the caller's tenant. The key hash is never included.
 * @summary List the tenant's API keys
 */
export const ListApiKeysResponseItem = zod.object({
  "id": zod.string(),
  "tenantId": zod.string().optional(),
  "userId": zod.string().nullish(),
  "name": zod.string(),
  "keyPrefix": zod.string(),
  "scopes": zod.array(zod.string()),
  "lastUsedAt": zod.string().nullish(),
  "expiresAt": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdAt": zod.string().nullish()
}).describe('API key row with the key hash stripped. Only the prefix of the secret is ever exposed after creation.')
export const ListApiKeysResponse = zod.array(ListApiKeysResponseItem)


/**
 * Creates a new API key for the caller's tenant. The plaintext key is returned once, only in this response.
 * @summary Create an API key
 */



export const CreateApiKeyBody = zod.object({
  "name": zod.string().min(1),
  "scopes": zod.array(zod.string()).optional(),
  "expiresAt": zod.string().nullish().describe('Optional ISO expiry timestamp')
})

export const CreateApiKeyResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string().optional(),
  "userId": zod.string().nullish(),
  "name": zod.string(),
  "keyPrefix": zod.string(),
  "scopes": zod.array(zod.string()),
  "lastUsedAt": zod.string().nullish(),
  "expiresAt": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdAt": zod.string().nullish()
}).describe('API key row with the key hash stripped. Only the prefix of the secret is ever exposed after creation.').and(zod.object({
  "plaintext": zod.string().describe('One-time plaintext key value; never retrievable again')
}))


/**
 * @summary Revoke an API key
 */
export const RevokeApiKeyParams = zod.object({
  "id": zod.coerce.string()
})

export const RevokeApiKeyResponse = zod.object({
  "message": zod.string()
})


/**
 * Replaces the key's secret with a new one. The new plaintext key is returned once, only in this response; the old key stops working.
 * @summary Rotate an API key
 */
export const RotateApiKeyParams = zod.object({
  "id": zod.coerce.string()
})

export const RotateApiKeyResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string().optional(),
  "userId": zod.string().nullish(),
  "name": zod.string(),
  "keyPrefix": zod.string(),
  "scopes": zod.array(zod.string()),
  "lastUsedAt": zod.string().nullish(),
  "expiresAt": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdAt": zod.string().nullish()
}).describe('API key row with the key hash stripped. Only the prefix of the secret is ever exposed after creation.').and(zod.object({
  "plaintext": zod.string().describe('One-time plaintext key value; never retrievable again')
}))


/**
 * Returns a short-lived, authenticated upload URL bound to the validated
 * size and content type. The client sends metadata here, then PUTs the
 * exact file bytes to the returned URL.
 * @summary Request a validated URL for file upload
 */
export const requestUploadUrlBodyNameMax = 255;

export const requestUploadUrlBodySizeMax = 52428800;



export const RequestUploadUrlBody = zod.object({
  "name": zod.string().min(1).max(requestUploadUrlBodyNameMax).describe('Original file name.'),
  "size": zod.int().min(1).max(requestUploadUrlBodySizeMax).describe('File size in bytes.'),
  "contentType": zod.enum(['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'application/pdf', 'audio/mpeg', 'audio/mp4', 'audio/ogg', 'audio/wav', 'audio/webm', 'video/mp4', 'video/webm', 'video/quicktime', 'text/plain', 'application/rtf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.oasis.opendocument.text']).describe('Allowed passive media or non-executable document MIME type.')
})

export const requestUploadUrlResponseMetadataNameMax = 255;

export const requestUploadUrlResponseMetadataSizeMax = 52428800;



export const RequestUploadUrlResponse = zod.object({
  "uploadURL": zod.url().describe('Short-lived authenticated URL for a size\/type-bound PUT upload.'),
  "objectPath": zod.string().describe('Normalized object path (e.g. `\/objects\/uploads\/uuid`). Store this in your database.'),
  "metadata": zod.object({
  "name": zod.string().min(1).max(requestUploadUrlResponseMetadataNameMax).describe('Original file name.'),
  "size": zod.int().min(1).max(requestUploadUrlResponseMetadataSizeMax).describe('File size in bytes.'),
  "contentType": zod.enum(['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'application/pdf', 'audio/mpeg', 'audio/mp4', 'audio/ogg', 'audio/wav', 'audio/webm', 'video/mp4', 'video/webm', 'video/quicktime', 'text/plain', 'application/rtf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.oasis.opendocument.text']).describe('Allowed passive media or non-executable document MIME type.')
}).optional()
})


/**
 * Unconditionally public — no authentication or ACL checks.
 * Searches PUBLIC_OBJECT_SEARCH_PATHS for the given file path.
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */
export const GetPublicObjectParams = zod.object({
  "filePath": zod.coerce.string().describe('Relative file path within the public search paths.')
})

export const GetPublicObjectResponse = zod.unknown()


/**
 * @summary Upload bytes to a validated object reservation
 */
export const UploadReservedObjectParams = zod.object({
  "objectId": zod.coerce.string()
})

export const UploadReservedObjectResponse = zod.object({
  "objectPath": zod.string()
})


/**
 * Serves object entities uploaded through validated reservations. These can optionally
 * be protected with authentication or ACL checks based on the use case.
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const GetStorageObjectParams = zod.object({
  "objectPath": zod.coerce.string().describe('Object path within the private object dir (e.g. `uploads\/some-uuid`).')
})

export const GetStorageObjectResponse = zod.unknown()


/**
 * Returns the template's run-history log — one entry per activation (load-from-template, daily instance start, or daily-cycle reset) with its start and completion stamps — newest first, capped at 200. View access to a shared template is sufficient.
 * @summary Run history for a checklist template
 */
export const ListChecklistTemplateHistoryParams = zod.object({
  "id": zod.coerce.string()
})

export const ListChecklistTemplateHistoryResponseItem = zod.object({
  "id": zod.string(),
  "templateId": zod.string().nullish(),
  "checklistId": zod.string().nullish(),
  "checklistName": zod.string(),
  "startedAt": zod.string(),
  "completedAt": zod.string().nullish(),
  "completedBy": zod.string().nullish()
}).describe('One run of a checklist template: stamped when started (activation or daily reset) and when completed. checklistId is null once the checklist instance has been deleted.')
export const ListChecklistTemplateHistoryResponse = zod.array(ListChecklistTemplateHistoryResponseItem)


/**
 * Returns the calendar-event occurrences linked to the checklist on the CALLER's own calendar (tenant + user scoped), ordered by startTime. Each occurrence carries isCompleted/completedAt for its day, powering the completion-history UI. View access to a shared checklist is sufficient.
 * @summary List the caller's calendar-event occurrences for a checklist
 */
export const ListChecklistOccurrencesParams = zod.object({
  "id": zod.coerce.string()
})

export const ListChecklistOccurrencesResponseItem = zod.object({
  "id": zod.string(),
  "startTime": zod.string().nullable(),
  "endTime": zod.string().nullish(),
  "allDay": zod.boolean(),
  "isRecurring": zod.boolean(),
  "isCompleted": zod.boolean(),
  "completedAt": zod.string().nullish()
}).describe('One calendar-event occurrence of a scheduled checklist on the caller\'s calendar, with its per-day completion state.')
export const ListChecklistOccurrencesResponse = zod.array(ListChecklistOccurrencesResponseItem)


/**
 * Creates a calendar event (or bounded recurring series) for the checklist on the caller's calendar, optionally best-effort pushing it to ONE connected Google calendar. When the push is attempted but fails, the response carries googlePushFailed: true so the UI can offer a retry via the retry-google-push endpoint.
 * @summary Schedule a checklist on the caller's calendar
 */
export const ScheduleChecklistParams = zod.object({
  "id": zod.coerce.string()
})

export const scheduleChecklistBodyAllDayDefault = false;
export const scheduleChecklistBodyRepeatDefault = `none`;

export const ScheduleChecklistBody = zod.object({
  "startTime": zod.string().describe('ISO date-time of the first occurrence'),
  "endTime": zod.string().optional().describe('ISO date-time; defaults to one hour after startTime'),
  "allDay": zod.boolean().default(scheduleChecklistBodyAllDayDefault),
  "targetCalendarId": zod.string().optional().describe('Optional single Google calendar to best-effort push the event to.'),
  "repeat": zod.enum(['none', 'daily', 'weekly']).default(scheduleChecklistBodyRepeatDefault)
})

export const ScheduleChecklistResponse = zod.object({
  "id": zod.string().optional(),
  "checklistId": zod.string().optional(),
  "startTime": zod.string().optional(),
  "endTime": zod.string().optional(),
  "isRecurring": zod.boolean().optional(),
  "googlePushFailed": zod.boolean().optional().describe('Present and true only when the best-effort Google push was attempted and failed; offer a retry via retry-google-push.')
}).describe('The created calendar event row. Extra server-side fields may be present and should be ignored by clients.')


/**
 * Deletes ALL calendar events linked to the checklist on the CALLER's calendar (recurring series and one-offs), with best-effort cleanup of Google-pushed copies. Removing the recurring events also stops the checklist's daily reset cycle, which is driven by them.
 * @summary Stop a checklist's recurring schedule and remove its calendar events
 */
export const UnscheduleChecklistParams = zod.object({
  "id": zod.coerce.string()
})

export const UnscheduleChecklistResponse = zod.object({
  "deleted": zod.int()
})


/**
 * Re-attempts the best-effort Google push for an already-created, still-unlinked local event or recurring series belonging to the caller. Returns 409 when the event is already linked to Google.
 * @summary Retry a failed Google Calendar push for a scheduled checklist
 */
export const RetryChecklistGooglePushParams = zod.object({
  "id": zod.coerce.string()
})

export const RetryChecklistGooglePushBody = zod.object({
  "eventId": zod.string().describe('Id of the caller\'s unlinked scheduled event'),
  "targetCalendarId": zod.string().describe('The Google calendar to push to')
})

export const RetryChecklistGooglePushResponse = zod.object({
  "success": zod.boolean()
})


/**
 * Machine-to-machine endpoint for an external cron (e.g. a Replit Scheduled Deployment) to ensure the hourly backup check runs even when the autoscale app has no traffic and no instance is alive to tick its internal setInterval. Requires a `Bearer SCHEDULER_TRIGGER_TOKEN` Authorization header; fail-closed (401) when the secret is unset or short. Returns 202 immediately and runs the check in the background.
 * @summary External scheduler trigger for the backup check
 */
export const TriggerBackupCheckResponse = zod.object({
  "status": zod.enum(['triggered'])
})


/**
 * Deletes all selected tasks and revokes assignment-created attachment shares in one transaction. If any task is not owned by the caller or any write fails, nothing is deleted.
 * @summary Delete owned tasks atomically
 */




export const BulkDeleteTasksBody = zod.object({
  "taskIds": zod.array(zod.string().min(1)).min(1)
})

export const BulkDeleteTasksResponse = zod.object({
  "deletedIds": zod.array(zod.string())
})


/**
 * Creates a new task for the authenticated user. Accepts an optional Idempotency-Key header; a duplicate request carrying the same key within 60 seconds returns the original 201 response without inserting a second row — safe to retry on flaky connections or proxy retries. For recurring tasks the response shape differs (see CreateRecurringTasksResponse).
 * @summary Create a task
 */
export const CreateTaskHeader = zod.object({
  "Idempotency-Key": zod.string().optional().describe('Client-generated unique key (e.g. a UUID) that deduplicates retried requests. A second POST with the same key and the same authenticated user within 60 seconds returns the originally created task without inserting a duplicate row.')
})

export const CreateTaskBody = zod.object({
  "checklistId": zod.string().nullish().describe('Optional attached checklist. Caller must already have access; attaching does not grant checklist permissions.'),
  "title": zod.string().describe('Task title'),
  "description": zod.string().nullish(),
  "category": zod.string().optional().describe('Task category (defaults to \"Uncategorized\")'),
  "priority": zod.enum(['low', 'medium', 'high', 'urgent']).optional().describe('Task priority (defaults to \"medium\")'),
  "tags": zod.array(zod.string()).optional(),
  "goalId": zod.string().nullish(),
  "milestoneId": zod.string().nullish(),
  "dueDate": zod.coerce.date().nullish(),
  "isRecurring": zod.boolean().optional(),
  "recurrenceFrequency": zod.enum(['daily', 'weekly', 'bi-weekly', 'monthly', 'quarterly', 'yearly']).nullish(),
  "recurrenceEndDate": zod.coerce.date().nullish(),
  "recurrenceCount": zod.int().nullish()
}).describe('Payload for creating a task. Only title is required; all other fields are optional and default to the server-side column defaults.')

export const CreateTaskResponse = zod.union([zod.object({
  "checklistId": zod.string().nullish().describe('Attached checklist ID, or null. Deleted checklists detach automatically.'),
  "id": zod.string(),
  "tenantId": zod.string(),
  "userId": zod.string(),
  "goalId": zod.string().nullish(),
  "milestoneId": zod.string().nullish(),
  "journalEntryId": zod.string().nullish(),
  "columnId": zod.string().nullish(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "category": zod.string(),
  "priority": zod.string(),
  "tags": zod.array(zod.string()),
  "assignedTo": zod.string(),
  "assignedToOther": zod.string().nullish(),
  "assignedToUserId": zod.string().nullish(),
  "completed": zod.boolean(),
  "isTopThree": zod.boolean(),
  "showOnMainTaskPage": zod.boolean(),
  "displayOrder": zod.int(),
  "dueDate": zod.coerce.date().nullish(),
  "isRecurring": zod.boolean(),
  "recurrenceFrequency": zod.string().nullish(),
  "recurrenceEndDate": zod.coerce.date().nullish(),
  "recurrenceCount": zod.int().nullish(),
  "recurrenceParentId": zod.string().nullish(),
  "isMasterRecurringTask": zod.boolean(),
  "isRecurringInstance": zod.boolean(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date()
}).describe('A single newly-created task row.'),zod.object({
  "message": zod.string().describe('Human-readable summary (\"Created N recurring tasks\")'),
  "tasks": zod.array(zod.object({
  "checklistId": zod.string().nullish().describe('Attached checklist ID, or null. Deleted checklists detach automatically.'),
  "id": zod.string(),
  "tenantId": zod.string(),
  "userId": zod.string(),
  "goalId": zod.string().nullish(),
  "milestoneId": zod.string().nullish(),
  "journalEntryId": zod.string().nullish(),
  "columnId": zod.string().nullish(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "category": zod.string(),
  "priority": zod.string(),
  "tags": zod.array(zod.string()),
  "assignedTo": zod.string(),
  "assignedToOther": zod.string().nullish(),
  "assignedToUserId": zod.string().nullish(),
  "completed": zod.boolean(),
  "isTopThree": zod.boolean(),
  "showOnMainTaskPage": zod.boolean(),
  "displayOrder": zod.int(),
  "dueDate": zod.coerce.date().nullish(),
  "isRecurring": zod.boolean(),
  "recurrenceFrequency": zod.string().nullish(),
  "recurrenceEndDate": zod.coerce.date().nullish(),
  "recurrenceCount": zod.int().nullish(),
  "recurrenceParentId": zod.string().nullish(),
  "isMasterRecurringTask": zod.boolean(),
  "isRecurringInstance": zod.boolean(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date()
}).describe('A single newly-created task row.')),
  "parentId": zod.string().describe('UUID shared by all instances in the recurring series')
}).describe('Response when a recurring task series is created.')])


/**
 * Returns the authenticated user's GoalVia-owned calendars in display order.
 * @summary List internal calendars
 */
export const listInternalCalendarsResponseColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const listInternalCalendarsResponseSortOrderMin = 0;



export const ListInternalCalendarsResponseItem = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "userId": zod.string(),
  "name": zod.string(),
  "color": zod.string().regex(listInternalCalendarsResponseColorRegExp),
  "isDefault": zod.boolean(),
  "isPlanningOnly": zod.boolean(),
  "isVisible": zod.boolean(),
  "sortOrder": zod.int().min(listInternalCalendarsResponseSortOrderMin),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date()
})
export const ListInternalCalendarsResponse = zod.array(ListInternalCalendarsResponseItem)


/**
 * Creates a GoalVia-owned calendar for the authenticated user.
 * @summary Create an internal calendar
 */
export const createInternalCalendarBodyNameMax = 255;

export const createInternalCalendarBodyColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createInternalCalendarBodyIsPlanningOnlyDefault = false;

export const CreateInternalCalendarBody = zod.object({
  "name": zod.string().min(1).max(createInternalCalendarBodyNameMax),
  "color": zod.string().regex(createInternalCalendarBodyColorRegExp).optional(),
  "isPlanningOnly": zod.boolean().default(createInternalCalendarBodyIsPlanningOnlyDefault)
})

export const createInternalCalendarResponseColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createInternalCalendarResponseSortOrderMin = 0;



export const CreateInternalCalendarResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "userId": zod.string(),
  "name": zod.string(),
  "color": zod.string().regex(createInternalCalendarResponseColorRegExp),
  "isDefault": zod.boolean(),
  "isPlanningOnly": zod.boolean(),
  "isVisible": zod.boolean(),
  "sortOrder": zod.int().min(createInternalCalendarResponseSortOrderMin),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date()
})


/**
 * Updates one or more editable fields on an authenticated user's internal calendar.
 * @summary Update an internal calendar
 */
export const UpdateInternalCalendarParams = zod.object({
  "id": zod.coerce.string()
})

export const updateInternalCalendarBodyNameMax = 255;

export const updateInternalCalendarBodyColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateInternalCalendarBodySortOrderMin = 0;



export const UpdateInternalCalendarBody = zod.object({
  "name": zod.string().min(1).max(updateInternalCalendarBodyNameMax).optional(),
  "color": zod.string().regex(updateInternalCalendarBodyColorRegExp).optional(),
  "isPlanningOnly": zod.boolean().optional(),
  "isVisible": zod.boolean().optional(),
  "sortOrder": zod.int().min(updateInternalCalendarBodySortOrderMin).optional()
})

export const updateInternalCalendarResponseColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateInternalCalendarResponseSortOrderMin = 0;



export const UpdateInternalCalendarResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "userId": zod.string(),
  "name": zod.string(),
  "color": zod.string().regex(updateInternalCalendarResponseColorRegExp),
  "isDefault": zod.boolean(),
  "isPlanningOnly": zod.boolean(),
  "isVisible": zod.boolean(),
  "sortOrder": zod.int().min(updateInternalCalendarResponseSortOrderMin),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date()
})


/**
 * Deletes an authenticated user's non-default internal calendar.
 * @summary Delete an internal calendar
 */
export const DeleteInternalCalendarParams = zod.object({
  "id": zod.coerce.string()
})

export const DeleteInternalCalendarResponse = zod.object({
  "success": zod.boolean()
})


/**
 * Copies safe event content into an owned internal calendar or a writable connected provider calendar. Provider IDs, recurrence, checklist, goal, task, habit, completion, and source identity are never copied.
 * @summary Clone a single calendar event
 */
export const CloneCalendarEventParams = zod.object({
  "id": zod.coerce.string()
})





export const CloneCalendarEventBody = zod.union([zod.object({
  "destinationInternalCalendarId": zod.string().min(1)
}),zod.object({
  "destinationExternalCalendarId": zod.string().min(1)
})])

export const CloneCalendarEventResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "userId": zod.string(),
  "internalCalendarId": zod.string().nullish(),
  "externalCalendarId": zod.string().nullish(),
  "externalEventId": zod.string().nullish(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "startTime": zod.coerce.date(),
  "endTime": zod.coerce.date(),
  "allDay": zod.boolean(),
  "location": zod.string().nullish(),
  "eventType": zod.string(),
  "category": zod.string().nullish(),
  "color": zod.string().nullish(),
  "isRecurring": zod.boolean(),
  "recurrenceRule": zod.string().nullish(),
  "recurringEventId": zod.string().nullish(),
  "checklistId": zod.string().nullish(),
  "goalId": zod.string().nullish(),
  "taskId": zod.string().nullish(),
  "habitId": zod.string().nullish(),
  "isCompleted": zod.boolean()
})


/**
 * Returns server health status
 * @summary Health check
 */
export const HealthCheckResponse = zod.object({
  "status": zod.string(),
  "migrationLock": zod.object({
  "state": zod.enum(['waiting', 'timed_out', 'acquired']),
  "waitingSince": zod.string().optional().describe('ISO timestamp of when the instance started waiting.'),
  "waitedSeconds": zod.number().optional(),
  "timeoutSeconds": zod.number().optional()
}).optional().describe('Present only when this instance has waited on the startup-migration advisory lock past the warning threshold. \"waiting\" means the instance is still polling for the lock; \"timed_out\" means the wait exceeded the timeout and the instance is about to exit; \"acquired\" means the lock was eventually obtained after a visible wait.')
})


/**
 * Returns the authenticated user's vision boards ordered by sortOrder then createdAt
 * @summary List vision boards
 */
export const ListVisionBoardsResponseItem = zod.object({
  "id": zod.string(),
  "tenantId": zod.string().optional(),
  "userId": zod.string().optional(),
  "name": zod.string(),
  "displayMode": zod.enum(['carousel', 'collage']),
  "slideIntervalSeconds": zod.int(),
  "images": zod.array(zod.object({
  "id": zod.string(),
  "source": zod.enum(['media', 'goal', 'drive']),
  "mediaFileId": zod.string().optional(),
  "goalId": zod.string().optional(),
  "driveFileId": zod.string().optional(),
  "url": zod.string().optional(),
  "name": zod.string().optional()
}).describe('One image on a vision board, referenced from the media library, a goal, or Google Drive')),
  "sortOrder": zod.int().optional(),
  "createdAt": zod.string().optional(),
  "updatedAt": zod.string().optional()
}).describe('A saved vision board')
export const ListVisionBoardsResponse = zod.array(ListVisionBoardsResponseItem)


/**
 * Creates a vision board with a name, display mode, slide interval, and up to 10 images
 * @summary Create a vision board
 */
export const createVisionBoardBodySlideIntervalSecondsMax = 3600;

export const createVisionBoardBodyImagesMax = 10;



export const CreateVisionBoardBody = zod.object({
  "name": zod.string().optional(),
  "displayMode": zod.enum(['carousel', 'collage']).optional(),
  "slideIntervalSeconds": zod.int().min(1).max(createVisionBoardBodySlideIntervalSecondsMax).optional(),
  "images": zod.array(zod.object({
  "id": zod.string(),
  "source": zod.enum(['media', 'goal', 'drive']),
  "mediaFileId": zod.string().optional(),
  "goalId": zod.string().optional(),
  "driveFileId": zod.string().optional(),
  "url": zod.string().optional(),
  "name": zod.string().optional()
}).describe('One image on a vision board, referenced from the media library, a goal, or Google Drive')).max(createVisionBoardBodyImagesMax).optional()
}).describe('Create\/update payload for a vision board')

export const CreateVisionBoardResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string().optional(),
  "userId": zod.string().optional(),
  "name": zod.string(),
  "displayMode": zod.enum(['carousel', 'collage']),
  "slideIntervalSeconds": zod.int(),
  "images": zod.array(zod.object({
  "id": zod.string(),
  "source": zod.enum(['media', 'goal', 'drive']),
  "mediaFileId": zod.string().optional(),
  "goalId": zod.string().optional(),
  "driveFileId": zod.string().optional(),
  "url": zod.string().optional(),
  "name": zod.string().optional()
}).describe('One image on a vision board, referenced from the media library, a goal, or Google Drive')),
  "sortOrder": zod.int().optional(),
  "createdAt": zod.string().optional(),
  "updatedAt": zod.string().optional()
}).describe('A saved vision board')


/**
 * Updates any subset of name, displayMode, slideIntervalSeconds, and images
 * @summary Update a vision board
 */
export const UpdateVisionBoardParams = zod.object({
  "id": zod.coerce.string()
})

export const updateVisionBoardBodySlideIntervalSecondsMax = 3600;

export const updateVisionBoardBodyImagesMax = 10;



export const UpdateVisionBoardBody = zod.object({
  "name": zod.string().optional(),
  "displayMode": zod.enum(['carousel', 'collage']).optional(),
  "slideIntervalSeconds": zod.int().min(1).max(updateVisionBoardBodySlideIntervalSecondsMax).optional(),
  "images": zod.array(zod.object({
  "id": zod.string(),
  "source": zod.enum(['media', 'goal', 'drive']),
  "mediaFileId": zod.string().optional(),
  "goalId": zod.string().optional(),
  "driveFileId": zod.string().optional(),
  "url": zod.string().optional(),
  "name": zod.string().optional()
}).describe('One image on a vision board, referenced from the media library, a goal, or Google Drive')).max(updateVisionBoardBodyImagesMax).optional()
}).describe('Create\/update payload for a vision board')

export const UpdateVisionBoardResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string().optional(),
  "userId": zod.string().optional(),
  "name": zod.string(),
  "displayMode": zod.enum(['carousel', 'collage']),
  "slideIntervalSeconds": zod.int(),
  "images": zod.array(zod.object({
  "id": zod.string(),
  "source": zod.enum(['media', 'goal', 'drive']),
  "mediaFileId": zod.string().optional(),
  "goalId": zod.string().optional(),
  "driveFileId": zod.string().optional(),
  "url": zod.string().optional(),
  "name": zod.string().optional()
}).describe('One image on a vision board, referenced from the media library, a goal, or Google Drive')),
  "sortOrder": zod.int().optional(),
  "createdAt": zod.string().optional(),
  "updatedAt": zod.string().optional()
}).describe('A saved vision board')


/**
 * Deletes the vision board owned by the authenticated user
 * @summary Delete a vision board
 */
export const DeleteVisionBoardParams = zod.object({
  "id": zod.coerce.string()
})

export const DeleteVisionBoardResponse = zod.void()


export const CreateResourceGrantBody = zod.object({
  "recipientUserId": zod.string(),
  "resourceType": zod.enum(['habit', 'goal', 'task', 'trackerx', 'media', 'calendar_event', 'calendar', 'note', 'planner_item', 'checklist', 'checklist_template', 'meal_plan', 'workout_plan', 'health_metric', 'food_goal', 'fitness_goal']),
  "resourceId": zod.string(),
  "permission": zod.enum(['view', 'edit', 'edit_delete'])
})

export const CreateResourceGrantResponse = zod.object({
  "recipientUserId": zod.string(),
  "resourceType": zod.enum(['habit', 'goal', 'task', 'trackerx', 'media', 'calendar_event', 'calendar', 'note', 'planner_item', 'checklist', 'checklist_template', 'meal_plan', 'workout_plan', 'health_metric', 'food_goal', 'fitness_goal']),
  "resourceId": zod.string(),
  "permission": zod.enum(['view', 'edit', 'edit_delete'])
}).and(zod.object({
  "id": zod.string(),
  "ownerTenantId": zod.string(),
  "ownerUserId": zod.string(),
  "revokedAt": zod.coerce.date().nullish(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date().optional(),
  "editable": zod.boolean().optional()
}))


export const ListSentResourceGrantsResponseItem = zod.object({
  "recipientUserId": zod.string(),
  "resourceType": zod.enum(['habit', 'goal', 'task', 'trackerx', 'media', 'calendar_event', 'calendar', 'note', 'planner_item', 'checklist', 'checklist_template', 'meal_plan', 'workout_plan', 'health_metric', 'food_goal', 'fitness_goal']),
  "resourceId": zod.string(),
  "permission": zod.enum(['view', 'edit', 'edit_delete'])
}).and(zod.object({
  "id": zod.string(),
  "ownerTenantId": zod.string(),
  "ownerUserId": zod.string(),
  "revokedAt": zod.coerce.date().nullish(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date().optional(),
  "editable": zod.boolean().optional()
})).and(zod.object({
  "displayName": zod.string(),
  "resourceTitle": zod.string(),
  "resourceSummary": zod.string().nullish(),
  "href": zod.string(),
  "resourceHref": zod.string().nullish(),
  "editable": zod.boolean()
}))
export const ListSentResourceGrantsResponse = zod.array(ListSentResourceGrantsResponseItem)


export const ListReceivedResourceGrantsResponseItem = zod.object({
  "recipientUserId": zod.string(),
  "resourceType": zod.enum(['habit', 'goal', 'task', 'trackerx', 'media', 'calendar_event', 'calendar', 'note', 'planner_item', 'checklist', 'checklist_template', 'meal_plan', 'workout_plan', 'health_metric', 'food_goal', 'fitness_goal']),
  "resourceId": zod.string(),
  "permission": zod.enum(['view', 'edit', 'edit_delete'])
}).and(zod.object({
  "id": zod.string(),
  "ownerTenantId": zod.string(),
  "ownerUserId": zod.string(),
  "revokedAt": zod.coerce.date().nullish(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date().optional(),
  "editable": zod.boolean().optional()
})).and(zod.object({
  "displayName": zod.string(),
  "resourceTitle": zod.string(),
  "resourceSummary": zod.string().nullish(),
  "href": zod.string(),
  "resourceHref": zod.string().nullish(),
  "editable": zod.boolean()
}))
export const ListReceivedResourceGrantsResponse = zod.array(ListReceivedResourceGrantsResponseItem)


export const UpdateResourceGrantParams = zod.object({
  "id": zod.coerce.string()
})

export const UpdateResourceGrantBody = zod.object({
  "permission": zod.enum(['view', 'edit', 'edit_delete'])
})

export const UpdateResourceGrantResponse = zod.object({
  "recipientUserId": zod.string(),
  "resourceType": zod.enum(['habit', 'goal', 'task', 'trackerx', 'media', 'calendar_event', 'calendar', 'note', 'planner_item', 'checklist', 'checklist_template', 'meal_plan', 'workout_plan', 'health_metric', 'food_goal', 'fitness_goal']),
  "resourceId": zod.string(),
  "permission": zod.enum(['view', 'edit', 'edit_delete'])
}).and(zod.object({
  "id": zod.string(),
  "ownerTenantId": zod.string(),
  "ownerUserId": zod.string(),
  "revokedAt": zod.coerce.date().nullish(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date().optional(),
  "editable": zod.boolean().optional()
}))


export const RevokeResourceGrantParams = zod.object({
  "id": zod.coerce.string()
})

export const RevokeResourceGrantResponse = zod.void()


export const GetGrantedResourceParams = zod.object({
  "id": zod.coerce.string()
})

export const GetGrantedResourceResponse = zod.union([zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['habit']),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "category": zod.string(),
  "frequency": zod.enum(['daily', 'weekly', 'monthly', 'quarterly']),
  "target": zod.int(),
  "isActive": zod.boolean()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['trackerx']),
  "name": zod.string(),
  "category": zod.string(),
  "valueType": zod.enum(['number', 'weight', 'currency']),
  "unitLabel": zod.string().nullish(),
  "period": zod.enum(['daily', 'weekly', 'monthly']),
  "goalValue": zod.number().nullish(),
  "timeSlots": zod.array(zod.string()).nullish(),
  "isActive": zod.boolean()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['media']),
  "name": zod.string(),
  "fileName": zod.string(),
  "category": zod.string(),
  "tags": zod.array(zod.string())
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['calendar_event']),
  "description": zod.string().nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "color": zod.string().nullish(),
  "allDay": zod.boolean()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['calendar']),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "color": zod.string().nullish(),
  "isVisible": zod.boolean()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['note']),
  "content": zod.unknown(),
  "plainContent": zod.string(),
  "tags": zod.array(zod.string()),
  "isPinned": zod.boolean()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['planner_item']),
  "text": zod.string(),
  "section": zod.enum(['week', 'month', 'quarter', 'year']),
  "dueDate": zod.coerce.date().nullish()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['meal_plan']),
  "mealType": zod.enum(['breakfast', 'lunch', 'dinner', 'snacks']),
  "foodName": zod.string(),
  "quantity": zod.number(),
  "servingUnit": zod.string(),
  "calories": zod.number().optional(),
  "protein": zod.number().optional(),
  "carbs": zod.number().optional(),
  "fat": zod.number().optional(),
  "fiber": zod.number().optional(),
  "sugar": zod.number().optional(),
  "saturatedFat": zod.number().optional(),
  "transFat": zod.number().optional(),
  "sodium": zod.number().optional()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['workout_plan']),
  "name": zod.string(),
  "notes": zod.string().nullish(),
  "durationMinutes": zod.int().nullish()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['health_metric']),
  "metricType": zod.string().nullish(),
  "value": zod.number().nullish(),
  "unit": zod.string().nullish(),
  "notes": zod.string().nullish()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['goal', 'task', 'checklist', 'checklist_template', 'food_goal', 'fitness_goal'])
}))])


export const UpdateGrantedResourceParams = zod.object({
  "id": zod.coerce.string()
})

export const updateGrantedResourceBodyOneNameMax = 500;

export const updateGrantedResourceBodyOneDescriptionMax = 5000;

export const updateGrantedResourceBodyOneCategoryMax = 500;


export const updateGrantedResourceBodyTwoNameMax = 500;

export const updateGrantedResourceBodyTwoCategoryMax = 500;

export const updateGrantedResourceBodyTwoUnitLabelMax = 100;

export const updateGrantedResourceBodyTwoGoalValueMin = 0;

export const updateGrantedResourceBodyTwoTimeSlotsMax = 24;

export const updateGrantedResourceBodyThreeNameMax = 500;

export const updateGrantedResourceBodyThreeCategoryMax = 500;

export const updateGrantedResourceBodyThreeTagsItemMax = 100;

export const updateGrantedResourceBodyThreeTagsMax = 100;

export const updateGrantedResourceBodyFourTitleMax = 500;

export const updateGrantedResourceBodyFourDescriptionMax = 5000;

export const updateGrantedResourceBodyFourLocationMax = 1000;

export const updateGrantedResourceBodyFourCategoryMax = 500;

export const updateGrantedResourceBodyFourColorMax = 100;

export const updateGrantedResourceBodyFiveColorMax = 100;

export const updateGrantedResourceBodySixTitleMax = 500;

export const updateGrantedResourceBodySixPlainContentMax = 100000;

export const updateGrantedResourceBodySixTagsItemMax = 100;

export const updateGrantedResourceBodySixTagsMax = 100;

export const updateGrantedResourceBodySevenTextMax = 500;

export const updateGrantedResourceBodyEightFoodNameMax = 500;

export const updateGrantedResourceBodyEightQuantityExclusiveMin = 0;

export const updateGrantedResourceBodyEightServingUnitMax = 500;

export const updateGrantedResourceBodyEightCaloriesMin = 0;

export const updateGrantedResourceBodyEightProteinMin = 0;

export const updateGrantedResourceBodyEightCarbsMin = 0;

export const updateGrantedResourceBodyEightFatMin = 0;

export const updateGrantedResourceBodyEightFiberMin = 0;

export const updateGrantedResourceBodyEightSugarMin = 0;

export const updateGrantedResourceBodyEightSaturatedFatMin = 0;

export const updateGrantedResourceBodyEightTransFatMin = 0;

export const updateGrantedResourceBodyEightSodiumMin = 0;

export const updateGrantedResourceBodyNineNameMax = 500;

export const updateGrantedResourceBodyNineNotesMax = 5000;

export const updateGrantedResourceBodyNineDurationMinutesMin = 0;

export const updateGrantedResourceBodyOnezeroUnitMax = 100;

export const updateGrantedResourceBodyOnezeroNotesMax = 5000;

export const updateGrantedResourceBodyOneoneTitleMax = 500;

export const updateGrantedResourceBodyOneoneSummaryMax = 5000;



export const UpdateGrantedResourceBody = zod.union([zod.object({
  "resourceType": zod.enum(['habit']),
  "name": zod.string().min(1).max(updateGrantedResourceBodyOneNameMax).optional(),
  "description": zod.string().max(updateGrantedResourceBodyOneDescriptionMax).nullish(),
  "category": zod.string().min(1).max(updateGrantedResourceBodyOneCategoryMax).optional(),
  "frequency": zod.enum(['daily', 'weekly', 'monthly', 'quarterly']).optional(),
  "target": zod.int().min(1).optional(),
  "isActive": zod.boolean().optional()
}),zod.object({
  "resourceType": zod.enum(['trackerx']),
  "name": zod.string().min(1).max(updateGrantedResourceBodyTwoNameMax).optional(),
  "category": zod.string().min(1).max(updateGrantedResourceBodyTwoCategoryMax).optional(),
  "valueType": zod.enum(['number', 'weight', 'currency']).optional(),
  "unitLabel": zod.string().max(updateGrantedResourceBodyTwoUnitLabelMax).nullish(),
  "period": zod.enum(['daily', 'weekly', 'monthly']).optional(),
  "goalValue": zod.number().min(updateGrantedResourceBodyTwoGoalValueMin).nullish(),
  "timeSlots": zod.array(zod.string()).max(updateGrantedResourceBodyTwoTimeSlotsMax).nullish(),
  "isActive": zod.boolean().optional()
}),zod.object({
  "resourceType": zod.enum(['media']),
  "name": zod.string().min(1).max(updateGrantedResourceBodyThreeNameMax).optional(),
  "category": zod.string().min(1).max(updateGrantedResourceBodyThreeCategoryMax).optional(),
  "tags": zod.array(zod.string().min(1).max(updateGrantedResourceBodyThreeTagsItemMax)).max(updateGrantedResourceBodyThreeTagsMax).optional()
}),zod.object({
  "resourceType": zod.enum(['calendar_event']),
  "title": zod.string().min(1).max(updateGrantedResourceBodyFourTitleMax).optional(),
  "description": zod.string().max(updateGrantedResourceBodyFourDescriptionMax).nullish(),
  "location": zod.string().max(updateGrantedResourceBodyFourLocationMax).nullish(),
  "category": zod.string().max(updateGrantedResourceBodyFourCategoryMax).nullish(),
  "color": zod.string().max(updateGrantedResourceBodyFourColorMax).nullish(),
  "allDay": zod.boolean().optional()
}),zod.object({
  "resourceType": zod.enum(['calendar']),
  "isVisible": zod.boolean().optional(),
  "color": zod.string().max(updateGrantedResourceBodyFiveColorMax).nullish()
}),zod.object({
  "resourceType": zod.enum(['note']),
  "title": zod.string().min(1).max(updateGrantedResourceBodySixTitleMax).optional(),
  "content": zod.unknown().optional(),
  "plainContent": zod.string().max(updateGrantedResourceBodySixPlainContentMax).optional(),
  "tags": zod.array(zod.string().min(1).max(updateGrantedResourceBodySixTagsItemMax)).max(updateGrantedResourceBodySixTagsMax).optional(),
  "isPinned": zod.boolean().optional()
}),zod.object({
  "resourceType": zod.enum(['planner_item']),
  "text": zod.string().min(1).max(updateGrantedResourceBodySevenTextMax).optional(),
  "section": zod.enum(['week', 'month', 'quarter', 'year']).optional(),
  "dueDate": zod.coerce.date().nullish()
}),zod.object({
  "resourceType": zod.enum(['meal_plan']),
  "mealType": zod.enum(['breakfast', 'lunch', 'dinner', 'snacks']).optional(),
  "foodName": zod.string().min(1).max(updateGrantedResourceBodyEightFoodNameMax).optional(),
  "quantity": zod.number().gt(updateGrantedResourceBodyEightQuantityExclusiveMin).optional(),
  "servingUnit": zod.string().min(1).max(updateGrantedResourceBodyEightServingUnitMax).optional(),
  "calories": zod.number().min(updateGrantedResourceBodyEightCaloriesMin).optional(),
  "protein": zod.number().min(updateGrantedResourceBodyEightProteinMin).optional(),
  "carbs": zod.number().min(updateGrantedResourceBodyEightCarbsMin).optional(),
  "fat": zod.number().min(updateGrantedResourceBodyEightFatMin).optional(),
  "fiber": zod.number().min(updateGrantedResourceBodyEightFiberMin).optional(),
  "sugar": zod.number().min(updateGrantedResourceBodyEightSugarMin).optional(),
  "saturatedFat": zod.number().min(updateGrantedResourceBodyEightSaturatedFatMin).optional(),
  "transFat": zod.number().min(updateGrantedResourceBodyEightTransFatMin).optional(),
  "sodium": zod.number().min(updateGrantedResourceBodyEightSodiumMin).optional()
}),zod.object({
  "resourceType": zod.enum(['workout_plan']),
  "name": zod.string().min(1).max(updateGrantedResourceBodyNineNameMax).optional(),
  "notes": zod.string().max(updateGrantedResourceBodyNineNotesMax).nullish(),
  "durationMinutes": zod.int().min(updateGrantedResourceBodyNineDurationMinutesMin).nullish()
}),zod.object({
  "resourceType": zod.enum(['health_metric']),
  "value": zod.number().optional(),
  "unit": zod.string().max(updateGrantedResourceBodyOnezeroUnitMax).optional(),
  "notes": zod.string().max(updateGrantedResourceBodyOnezeroNotesMax).nullish()
}),zod.object({
  "resourceType": zod.enum(['goal', 'task', 'checklist', 'checklist_template', 'food_goal', 'fitness_goal']),
  "title": zod.string().min(1).max(updateGrantedResourceBodyOneoneTitleMax).optional(),
  "summary": zod.string().max(updateGrantedResourceBodyOneoneSummaryMax).nullish()
})])

export const UpdateGrantedResourceResponse = zod.union([zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['habit']),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "category": zod.string(),
  "frequency": zod.enum(['daily', 'weekly', 'monthly', 'quarterly']),
  "target": zod.int(),
  "isActive": zod.boolean()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['trackerx']),
  "name": zod.string(),
  "category": zod.string(),
  "valueType": zod.enum(['number', 'weight', 'currency']),
  "unitLabel": zod.string().nullish(),
  "period": zod.enum(['daily', 'weekly', 'monthly']),
  "goalValue": zod.number().nullish(),
  "timeSlots": zod.array(zod.string()).nullish(),
  "isActive": zod.boolean()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['media']),
  "name": zod.string(),
  "fileName": zod.string(),
  "category": zod.string(),
  "tags": zod.array(zod.string())
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['calendar_event']),
  "description": zod.string().nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "color": zod.string().nullish(),
  "allDay": zod.boolean()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['calendar']),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "color": zod.string().nullish(),
  "isVisible": zod.boolean()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['note']),
  "content": zod.unknown(),
  "plainContent": zod.string(),
  "tags": zod.array(zod.string()),
  "isPinned": zod.boolean()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['planner_item']),
  "text": zod.string(),
  "section": zod.enum(['week', 'month', 'quarter', 'year']),
  "dueDate": zod.coerce.date().nullish()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['meal_plan']),
  "mealType": zod.enum(['breakfast', 'lunch', 'dinner', 'snacks']),
  "foodName": zod.string(),
  "quantity": zod.number(),
  "servingUnit": zod.string(),
  "calories": zod.number().optional(),
  "protein": zod.number().optional(),
  "carbs": zod.number().optional(),
  "fat": zod.number().optional(),
  "fiber": zod.number().optional(),
  "sugar": zod.number().optional(),
  "saturatedFat": zod.number().optional(),
  "transFat": zod.number().optional(),
  "sodium": zod.number().optional()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['workout_plan']),
  "name": zod.string(),
  "notes": zod.string().nullish(),
  "durationMinutes": zod.int().nullish()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['health_metric']),
  "metricType": zod.string().nullish(),
  "value": zod.number().nullish(),
  "unit": zod.string().nullish(),
  "notes": zod.string().nullish()
})),zod.object({
  "id": zod.string(),
  "resourceType": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "href": zod.string()
}).and(zod.object({
  "resourceType": zod.enum(['goal', 'task', 'checklist', 'checklist_template', 'food_goal', 'fitness_goal'])
}))])


export const CreateDeletionRequestParams = zod.object({
  "id": zod.coerce.string()
})

export const createDeletionRequestBodyReasonMax = 1000;



export const CreateDeletionRequestBody = zod.object({
  "reason": zod.string().max(createDeletionRequestBodyReasonMax).optional()
})

export const CreateDeletionRequestResponse = zod.object({
  "id": zod.string(),
  "grantId": zod.string(),
  "ownerTenantId": zod.string(),
  "resourceType": zod.string(),
  "resourceId": zod.string(),
  "requestedByUserId": zod.string(),
  "status": zod.enum(['pending', 'approved', 'rejected', 'deleted']),
  "decisionByUserId": zod.string().nullish(),
  "reason": zod.string().nullish(),
  "decidedAt": zod.coerce.date().nullish(),
  "createdAt": zod.coerce.date()
})


export const DecideDeletionRequestLegacyParams = zod.object({
  "id": zod.coerce.string(),
  "decision": zod.enum(['approve', 'reject'])
})

export const decideDeletionRequestLegacyBodyReasonMax = 1000;



export const DecideDeletionRequestLegacyBody = zod.object({
  "reason": zod.string().max(decideDeletionRequestLegacyBodyReasonMax).optional()
})

export const DecideDeletionRequestLegacyResponse = zod.object({
  "id": zod.string(),
  "grantId": zod.string(),
  "ownerTenantId": zod.string(),
  "resourceType": zod.string(),
  "resourceId": zod.string(),
  "requestedByUserId": zod.string(),
  "status": zod.enum(['pending', 'approved', 'rejected', 'deleted']),
  "decisionByUserId": zod.string().nullish(),
  "reason": zod.string().nullish(),
  "decidedAt": zod.coerce.date().nullish(),
  "createdAt": zod.coerce.date()
})


export const ListDeletionRequestsResponseItem = zod.object({
  "id": zod.string(),
  "grantId": zod.string(),
  "ownerTenantId": zod.string(),
  "resourceType": zod.string(),
  "resourceId": zod.string(),
  "requestedByUserId": zod.string(),
  "status": zod.enum(['pending', 'approved', 'rejected', 'deleted']),
  "decisionByUserId": zod.string().nullish(),
  "reason": zod.string().nullish(),
  "decidedAt": zod.coerce.date().nullish(),
  "createdAt": zod.coerce.date()
}).and(zod.object({
  "role": zod.enum(['owner', 'requester']),
  "displayName": zod.string(),
  "resourceTitle": zod.string(),
  "resourceSummary": zod.string().nullish(),
  "href": zod.string()
}))
export const ListDeletionRequestsResponse = zod.array(ListDeletionRequestsResponseItem)


export const DecideDeletionRequestParams = zod.object({
  "id": zod.coerce.string(),
  "decision": zod.enum(['approve', 'reject'])
})

export const decideDeletionRequestBodyReasonMax = 1000;



export const DecideDeletionRequestBody = zod.object({
  "reason": zod.string().max(decideDeletionRequestBodyReasonMax).optional()
})

export const DecideDeletionRequestResponse = zod.object({
  "id": zod.string(),
  "grantId": zod.string(),
  "ownerTenantId": zod.string(),
  "resourceType": zod.string(),
  "resourceId": zod.string(),
  "requestedByUserId": zod.string(),
  "status": zod.enum(['pending', 'approved', 'rejected', 'deleted']),
  "decisionByUserId": zod.string().nullish(),
  "reason": zod.string().nullish(),
  "decidedAt": zod.coerce.date().nullish(),
  "createdAt": zod.coerce.date()
})


export const ExecuteApprovedDeletionParams = zod.object({
  "id": zod.coerce.string()
})

export const ExecuteApprovedDeletionResponse = zod.void()


/**
 * @summary Get current effective platform permissions
 */
export const GetCurrentPlatformPermissionsResponse = zod.object({
  "isPlatformOwner": zod.boolean(),
  "effectivePermissions": zod.array(zod.enum(['tenant.provision', 'user.invite', 'billing.view', 'billing.manage', 'plan.assign']))
})


/**
 * @summary List platform roles (owner only)
 */
export const listPlatformRolesResponsePermissionsMax = 6;



export const ListPlatformRolesResponseItem = zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "isEnabled": zod.boolean(),
  "createdByUserId": zod.string().nullable(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date(),
  "permissions": zod.array(zod.enum(['tenant.provision', 'user.invite', 'billing.view', 'billing.manage', 'plan.assign'])).max(listPlatformRolesResponsePermissionsMax)
})
export const ListPlatformRolesResponse = zod.array(ListPlatformRolesResponseItem)


/**
 * @summary Create platform role (owner only)
 */
export const createPlatformRoleBodyNameMax = 120;

export const createPlatformRoleBodyDescriptionMax = 2000;

export const createPlatformRoleBodyPermissionsMax = 6;



export const CreatePlatformRoleBody = zod.object({
  "name": zod.string().min(1).max(createPlatformRoleBodyNameMax),
  "description": zod.string().max(createPlatformRoleBodyDescriptionMax).nullish(),
  "isEnabled": zod.boolean().optional(),
  "permissions": zod.array(zod.enum(['tenant.provision', 'user.invite', 'billing.view', 'billing.manage', 'plan.assign'])).max(createPlatformRoleBodyPermissionsMax).optional()
})

export const createPlatformRoleResponsePermissionsMax = 6;



export const CreatePlatformRoleResponse = zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "isEnabled": zod.boolean(),
  "createdByUserId": zod.string().nullable(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date(),
  "permissions": zod.array(zod.enum(['tenant.provision', 'user.invite', 'billing.view', 'billing.manage', 'plan.assign'])).max(createPlatformRoleResponsePermissionsMax)
})


/**
 * @summary Update platform role (owner only)
 */
export const UpdatePlatformRoleParams = zod.object({
  "id": zod.coerce.string()
})

export const updatePlatformRoleBodyNameMax = 120;

export const updatePlatformRoleBodyDescriptionMax = 2000;

export const updatePlatformRoleBodyPermissionsMax = 6;



export const UpdatePlatformRoleBody = zod.object({
  "name": zod.string().min(1).max(updatePlatformRoleBodyNameMax).optional(),
  "description": zod.string().max(updatePlatformRoleBodyDescriptionMax).nullish(),
  "isEnabled": zod.boolean().optional(),
  "permissions": zod.array(zod.enum(['tenant.provision', 'user.invite', 'billing.view', 'billing.manage', 'plan.assign'])).max(updatePlatformRoleBodyPermissionsMax).optional()
})

export const updatePlatformRoleResponsePermissionsMax = 6;



export const UpdatePlatformRoleResponse = zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "isEnabled": zod.boolean(),
  "createdByUserId": zod.string().nullable(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date(),
  "permissions": zod.array(zod.enum(['tenant.provision', 'user.invite', 'billing.view', 'billing.manage', 'plan.assign'])).max(updatePlatformRoleResponsePermissionsMax)
})


/**
 * @summary Delete platform role (owner only)
 */
export const DeletePlatformRoleParams = zod.object({
  "id": zod.coerce.string()
})

export const DeletePlatformRoleResponse = zod.void()


/**
 * @summary Assign platform role (owner only)
 */
export const AssignPlatformRoleParams = zod.object({
  "id": zod.coerce.string()
})




export const AssignPlatformRoleBody = zod.object({
  "userId": zod.string().min(1)
})

export const AssignPlatformRoleResponse = zod.object({
  "id": zod.string(),
  "roleId": zod.string(),
  "userId": zod.string(),
  "assignedByUserId": zod.string().nullable(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary List platform role assignments (owner only)
 */
export const ListPlatformRoleAssignmentsResponseItem = zod.object({
  "id": zod.string(),
  "roleId": zod.string(),
  "userId": zod.string(),
  "assignedByUserId": zod.string().nullable(),
  "createdAt": zod.coerce.date()
}).and(zod.object({
  "roleName": zod.string(),
  "userEmail": zod.string(),
  "userName": zod.string().nullable()
}))
export const ListPlatformRoleAssignmentsResponse = zod.array(ListPlatformRoleAssignmentsResponseItem)


/**
 * @summary Remove platform role assignment (owner only)
 */
export const UnassignPlatformRoleParams = zod.object({
  "id": zod.coerce.string(),
  "userId": zod.coerce.string()
})

export const UnassignPlatformRoleResponse = zod.void()


/**
 * Aggregates the authenticated user's goals, habits, tasks, trackers, health, and calendar data for the requested period and produces an AI-generated scorecard with scores (1-10 per category), a composite score, strengths, improvement areas, a coach message, and priority actions.
 * @summary Generate an AI-powered performance scorecard
 */
export const AnalyzeScorecardPerformanceBody = zod.object({
  "period": zod.enum(['daily', 'weekly', 'monthly', 'quarterly', 'yearly']).optional().describe('Time granularity for a scorecard request.'),
  "rangeType": zod.enum(['rolling', 'calendar']).optional().describe('\"rolling\" uses a trailing N-day window; \"calendar\" snaps to the current calendar month or quarter boundary.')
})


export const analyzeScorecardPerformanceResponseScoresGoalsMax = 10;

export const analyzeScorecardPerformanceResponseScoresHabitsMax = 10;

export const analyzeScorecardPerformanceResponseScoresTrackersMax = 10;

export const analyzeScorecardPerformanceResponseScoresHealthMax = 10;

export const analyzeScorecardPerformanceResponseScoresTasksMax = 10;



export const AnalyzeScorecardPerformanceResponse = zod.object({
  "period": zod.enum(['daily', 'weekly', 'monthly', 'quarterly', 'yearly']).describe('Time granularity for a scorecard request.'),
  "rangeType": zod.enum(['rolling', 'calendar']).describe('\"rolling\" uses a trailing N-day window; \"calendar\" snaps to the current calendar month or quarter boundary.'),
  "label": zod.string().describe('Human-readable period label (e.g. \"Last 7 days\").'),
  "start": zod.coerce.date().describe('Start of the analysis window (ISO 8601).'),
  "end": zod.coerce.date().describe('End of the analysis window (ISO 8601).'),
  "daysInRange": zod.int().min(1),
  "scores": zod.object({
  "goals": zod.int().min(1).max(analyzeScorecardPerformanceResponseScoresGoalsMax),
  "habits": zod.int().min(1).max(analyzeScorecardPerformanceResponseScoresHabitsMax),
  "trackers": zod.int().min(1).max(analyzeScorecardPerformanceResponseScoresTrackersMax),
  "health": zod.int().min(1).max(analyzeScorecardPerformanceResponseScoresHealthMax),
  "tasks": zod.int().min(1).max(analyzeScorecardPerformanceResponseScoresTasksMax)
}).describe('Per-category scores on a 1-10 scale.'),
  "composite": zod.number().describe('Weighted composite score (1.0-10.0, one decimal place).'),
  "strengths": zod.array(zod.string()),
  "improvements": zod.array(zod.string()),
  "coachMessage": zod.string().describe('AI coach narrative (3-5 sentences, direct and data-specific).'),
  "priorityActions": zod.array(zod.string()),
  "metrics": zod.record(zod.string(), zod.unknown()).describe('Raw aggregated metrics used to produce the scores.')
})


/**
 * Sends a user message to the AI performance coach, optionally including the current scorecard context and prior conversation history so the coach can reference specific scores and metrics in its reply.
 * @summary Chat with the AI performance coach
 */
export const scorecardChatBodyMessageMax = 4000;

export const scorecardChatBodyConversationHistoryItemContentMax = 2000;

export const scorecardChatBodyConversationHistoryMax = 40;

export const scorecardChatBodyScorecardContextScoresGoalsMax = 10;

export const scorecardChatBodyScorecardContextScoresHabitsMax = 10;

export const scorecardChatBodyScorecardContextScoresTrackersMax = 10;

export const scorecardChatBodyScorecardContextScoresHealthMax = 10;

export const scorecardChatBodyScorecardContextScoresTasksMax = 10;



export const ScorecardChatBody = zod.object({
  "message": zod.string().min(1).max(scorecardChatBodyMessageMax).describe('The user\'s message to the AI performance coach.'),
  "conversationHistory": zod.array(zod.object({
  "role": zod.enum(['user', 'assistant']),
  "content": zod.string().max(scorecardChatBodyConversationHistoryItemContentMax)
})).max(scorecardChatBodyConversationHistoryMax).optional().describe('Prior turns of the conversation (newest last). At most 20 are sent to the model.'),
  "scorecardContext": zod.object({
  "label": zod.string().optional().describe('Human-readable period label (e.g. \"Last 7 days\").'),
  "composite": zod.number().optional().describe('Weighted composite score (1.0-10.0).'),
  "scores": zod.object({
  "goals": zod.int().min(1).max(scorecardChatBodyScorecardContextScoresGoalsMax),
  "habits": zod.int().min(1).max(scorecardChatBodyScorecardContextScoresHabitsMax),
  "trackers": zod.int().min(1).max(scorecardChatBodyScorecardContextScoresTrackersMax),
  "health": zod.int().min(1).max(scorecardChatBodyScorecardContextScoresHealthMax),
  "tasks": zod.int().min(1).max(scorecardChatBodyScorecardContextScoresTasksMax)
}).optional().describe('Per-category scores on a 1-10 scale.'),
  "strengths": zod.array(zod.string()).optional(),
  "improvements": zod.array(zod.string()).optional(),
  "coachMessage": zod.string().optional()
}).optional().describe('Optional partial scorecard snapshot to give the coach context. Only the fields the coach reads are required; the full analyze response shape is NOT needed here.')
})

export const ScorecardChatResponse = zod.object({
  "response": zod.string().describe('The AI coach\'s reply.')
})


/**
 * Returns an array of time-bucketed scorecard snapshots (one per period bucket) computed from rule-based scoring without AI. Useful for rendering trend charts. Max window counts: daily=30, weekly=4, monthly=3, quarterly=4, yearly=3.
 * @summary Compute rule-based scorecard trend over time buckets
 */
export const getScorecardTrendBodyWindowCountDefault = 7;



export const GetScorecardTrendBody = zod.object({
  "period": zod.enum(['daily', 'weekly', 'monthly', 'quarterly', 'yearly']).optional().describe('Time granularity for a scorecard request.'),
  "windowCount": zod.int().min(1).default(getScorecardTrendBodyWindowCountDefault).describe('Number of time buckets to return. Capped server-side by period: daily≤30, weekly≤4, monthly≤3, quarterly≤4, yearly≤3.')
})

export const getScorecardTrendResponseScoresGoalsMax = 10;

export const getScorecardTrendResponseScoresHabitsMax = 10;

export const getScorecardTrendResponseScoresTrackersMax = 10;

export const getScorecardTrendResponseScoresHealthMax = 10;

export const getScorecardTrendResponseScoresTasksMax = 10;




export const GetScorecardTrendResponseItem = zod.object({
  "label": zod.string().describe('Human-readable bucket label (e.g. \"Sep 1\", \"Sep \'26\", \"Q3 \'26\").'),
  "startDate": zod.coerce.date().describe('First calendar day of the bucket (YYYY-MM-DD).'),
  "endDate": zod.coerce.date().describe('Last calendar day of the bucket (YYYY-MM-DD).'),
  "composite": zod.number().describe('Weighted composite score for this bucket (1.0-10.0).'),
  "scores": zod.object({
  "goals": zod.int().min(1).max(getScorecardTrendResponseScoresGoalsMax),
  "habits": zod.int().min(1).max(getScorecardTrendResponseScoresHabitsMax),
  "trackers": zod.int().min(1).max(getScorecardTrendResponseScoresTrackersMax),
  "health": zod.int().min(1).max(getScorecardTrendResponseScoresHealthMax),
  "tasks": zod.int().min(1).max(getScorecardTrendResponseScoresTasksMax)
}).describe('Per-category scores on a 1-10 scale.'),
  "daysInPeriod": zod.int().min(1)
})
export const GetScorecardTrendResponse = zod.array(GetScorecardTrendResponseItem)


/**
 * @summary Get the daily spending budget for an assistant or family relationship
 */
export const GetRelationshipSpendingBudgetParams = zod.object({
  "personUserId": zod.coerce.string()
})

export const getRelationshipSpendingBudgetResponseDailyLimitCentsMin = 0;

export const getRelationshipSpendingBudgetResponseSpentCentsMin = 0;

export const getRelationshipSpendingBudgetResponseReservedCentsMin = 0;

export const getRelationshipSpendingBudgetResponsePendingCentsMin = 0;

export const getRelationshipSpendingBudgetResponseApprovedCentsMin = 0;

export const getRelationshipSpendingBudgetResponsePendingApprovalCentsMin = 0;

export const getRelationshipSpendingBudgetResponseRemainingCentsMin = 0;



export const GetRelationshipSpendingBudgetResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "friendshipId": zod.string(),
  "dailyLimitCents": zod.int().min(getRelationshipSpendingBudgetResponseDailyLimitCentsMin),
  "timezone": zod.string(),
  "isActive": zod.boolean(),
  "usageDate": zod.coerce.date(),
  "spentCents": zod.int().min(getRelationshipSpendingBudgetResponseSpentCentsMin),
  "reservedCents": zod.int().min(getRelationshipSpendingBudgetResponseReservedCentsMin),
  "pendingCents": zod.int().min(getRelationshipSpendingBudgetResponsePendingCentsMin),
  "approvedCents": zod.int().min(getRelationshipSpendingBudgetResponseApprovedCentsMin),
  "pendingApprovalCents": zod.int().min(getRelationshipSpendingBudgetResponsePendingApprovalCentsMin),
  "remainingCents": zod.int().min(getRelationshipSpendingBudgetResponseRemainingCentsMin),
  "relationship": zod.object({
  "friendshipId": zod.string(),
  "tenantId": zod.string(),
  "managerUserId": zod.string(),
  "personUserId": zod.string()
})
})


/**
 * @summary Set the daily spending budget for an assistant or family relationship
 */
export const UpdateRelationshipSpendingBudgetParams = zod.object({
  "personUserId": zod.coerce.string()
})

export const updateRelationshipSpendingBudgetBodyDailyLimitCentsMin = 0;
export const updateRelationshipSpendingBudgetBodyDailyLimitCentsMax = 10000000;



export const UpdateRelationshipSpendingBudgetBody = zod.object({
  "dailyLimitCents": zod.int().min(updateRelationshipSpendingBudgetBodyDailyLimitCentsMin).max(updateRelationshipSpendingBudgetBodyDailyLimitCentsMax)
})

export const updateRelationshipSpendingBudgetResponseDailyLimitCentsMin = 0;

export const updateRelationshipSpendingBudgetResponseSpentCentsMin = 0;

export const updateRelationshipSpendingBudgetResponseReservedCentsMin = 0;

export const updateRelationshipSpendingBudgetResponsePendingCentsMin = 0;

export const updateRelationshipSpendingBudgetResponseApprovedCentsMin = 0;

export const updateRelationshipSpendingBudgetResponsePendingApprovalCentsMin = 0;

export const updateRelationshipSpendingBudgetResponseRemainingCentsMin = 0;



export const UpdateRelationshipSpendingBudgetResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "friendshipId": zod.string(),
  "dailyLimitCents": zod.int().min(updateRelationshipSpendingBudgetResponseDailyLimitCentsMin),
  "timezone": zod.string(),
  "isActive": zod.boolean(),
  "usageDate": zod.coerce.date(),
  "spentCents": zod.int().min(updateRelationshipSpendingBudgetResponseSpentCentsMin),
  "reservedCents": zod.int().min(updateRelationshipSpendingBudgetResponseReservedCentsMin),
  "pendingCents": zod.int().min(updateRelationshipSpendingBudgetResponsePendingCentsMin),
  "approvedCents": zod.int().min(updateRelationshipSpendingBudgetResponseApprovedCentsMin),
  "pendingApprovalCents": zod.int().min(updateRelationshipSpendingBudgetResponsePendingApprovalCentsMin),
  "remainingCents": zod.int().min(updateRelationshipSpendingBudgetResponseRemainingCentsMin),
  "relationship": zod.object({
  "friendshipId": zod.string(),
  "tenantId": zod.string(),
  "managerUserId": zod.string(),
  "personUserId": zod.string()
})
})


/**
 * @summary Approve additional spending for an assistant or family relationship
 */
export const ApproveRelationshipSpendingParams = zod.object({
  "approvalId": zod.coerce.string()
})


export const approveRelationshipSpendingBodyDailyLimitCentsMin = 0;
export const approveRelationshipSpendingBodyDailyLimitCentsMax = 10000000;



export const ApproveRelationshipSpendingBody = zod.object({
  "additionalCents": zod.int().min(1).optional(),
  "dailyLimitCents": zod.int().min(approveRelationshipSpendingBodyDailyLimitCentsMin).max(approveRelationshipSpendingBodyDailyLimitCentsMax).optional()
})


export const approveRelationshipSpendingResponseApprovedCentsMin = 0;



export const ApproveRelationshipSpendingResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "friendshipId": zod.string(),
  "requesterUserId": zod.string(),
  "usageDate": zod.coerce.date(),
  "status": zod.enum(['pending', 'approved', 'denied']),
  "requestedCents": zod.int().min(1),
  "approvedCents": zod.int().min(approveRelationshipSpendingResponseApprovedCentsMin).optional(),
  "approverUserId": zod.string().nullish(),
  "resolvedAt": zod.coerce.date().nullish()
})


/**
 * @summary Deny additional spending for an assistant or family relationship
 */
export const DenyRelationshipSpendingParams = zod.object({
  "approvalId": zod.coerce.string()
})


export const denyRelationshipSpendingResponseApprovedCentsMin = 0;



export const DenyRelationshipSpendingResponse = zod.object({
  "id": zod.string(),
  "tenantId": zod.string(),
  "friendshipId": zod.string(),
  "requesterUserId": zod.string(),
  "usageDate": zod.coerce.date(),
  "status": zod.enum(['pending', 'approved', 'denied']),
  "requestedCents": zod.int().min(1),
  "approvedCents": zod.int().min(denyRelationshipSpendingResponseApprovedCentsMin).optional(),
  "approverUserId": zod.string().nullish(),
  "resolvedAt": zod.coerce.date().nullish()
})


